import { useOpenBalanceContext } from "../context/OpenBalanceContext";
export const useOrderInfoSection = () => {
    var _a, _b;
    const OBP = useOpenBalanceContext();
    const textSX = { fontWeight: 500 };
    const orderNumber = (_a = OBP.targetOrder) === null || _a === void 0 ? void 0 : _a.OrderNumber;
    const orderId = (_b = OBP.targetOrder) === null || _b === void 0 ? void 0 : _b.OrderId;
    const showInvoiceButton = !!OBP.targetOrder && !!OBP.targetOrderInfo;
    return {
        isMobile: OBP.isMobile,
        orderId,
        orderNumber,
        remainingBalanceDisplay: OBP.remainingBalanceDisplay,
        setOpenInvoice: OBP.setOpenInvoice,
        showInvoiceButton,
        textSX,
    };
};
